import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PDFViewerComponent from './components/PDFViewerComponent';
import EtiquetaEmpaqueViewer from './components/EtiquetaEmpaqueViewer';

const App = () => (
  <Router>
    <Routes>
      <Route path="/info-armado" element={<PDFViewerComponent />} />
      <Route path="/etiqueta-empaque" element={<EtiquetaEmpaqueViewer />} />
    </Routes>
  </Router>
);

export default App;
